import { render, staticRenderFns } from "./openWX.vue?vue&type=template&id=43bd9a14&scoped=true&"
import script from "./openWX.vue?vue&type=script&lang=js&"
export * from "./openWX.vue?vue&type=script&lang=js&"
import style0 from "./openWX.vue?vue&type=style&index=0&id=43bd9a14&prod&scoped=true&lang=css&"
import style1 from "./openWX.vue?vue&type=style&index=1&id=43bd9a14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd9a14",
  null
  
)

export default component.exports